// extracted by mini-css-extract-plugin
module.exports = {"title":"ArticleCardContent_title__1w9qC","sending":"ArticleCardContent_sending__21wSM"};